import { Component, Inject, Input, OnDestroy } from '@angular/core';

import { emitedEventsTypes } from '@src/constants';
import { packagesActions } from '@src/store/reducers/packagesReducer';
import { Store } from '@src/store';

@Component({
    selector: 'package-affected-objects',
    template: require('./package-affected-objects.component.html')
})
export class PackageAffectedObjectsComponent implements OnDestroy {
    @Input() public projectId: any;
    public affectedObjectList: any = null;
    public onSelectedPackageEvent: any;

    constructor(private store: Store, @Inject('$scope') $scope: any) {
        this.onSelectedPackageEvent = $scope.$on(emitedEventsTypes.selectedPackageEvent, async (_: any, data: any) => {
            const payload = { projectId: this.projectId, packageId: data.packageId };
            const response = await this.store.dispatch({ payload, type: packagesActions.GET_AFFECTED_OBJECTS });
            this.affectedObjectList = response.data;
        });
    }

    public ngOnDestroy() {
        this.onSelectedPackageEvent();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/packages/packages-list/package-affected-objects/package-affected-objects.component.ts